// AWS S3 Configuration - Credentials fetched from backend
let awsCredentials = null;
import axios from 'axios';

// Function to fetch AWS credentials from backend
const fetchAWSCredentials = async () => {
    if (awsCredentials) {
        return awsCredentials;
    }
    
    try {
        const response = await axios.get(`${process.env.REACT_APP_PATH}/api/getAWSAccessKeys`);
        if (!response.data) {
            throw new Error('Failed to fetch AWS credentials');
        }
        const data = response.data;
        awsCredentials = {
            accessKeyId: data.accessKey,
            secretAccessKey: data.secret
        };
        console.log('awsCredentials', awsCredentials);
        return awsCredentials;
    } catch (error) {
        console.error('Error fetching AWS credentials:', error);
        throw error;
    }
};

// Base S3 configuration (without credentials)
const getBaseS3Config = (dirName = 'sms-marketing') => ({
    bucketName: 'buyumecrm',
    region: 'ap-south-1',
    dirName: dirName
});

// Function to get complete S3 config with credentials
const getS3Config = async (dirName = 'sms-marketing') => {
    const credentials = await fetchAWSCredentials();
    return {
        ...getBaseS3Config(dirName),
        ...credentials
    };
};

// Legacy export for backward compatibility
const config_s3 = {
    bucketName: 'buyumecrm',
    region: 'ap-south-1',
    dirName: 'sms-marketing',
    // Note: accessKeyId and secretAccessKey are now fetched dynamically
};

export { config_s3, getS3Config, getBaseS3Config, fetchAWSCredentials }